import React from "react";
import { Instagram, Youtube, Music2, Twitter } from "lucide-react";
import { ASSETS, ARTIST, SOCIALS } from "../mock";

const iconFor = (key) => {
  switch (key) {
    case "instagram":
      return <Instagram size={16} />;
    case "youtube":
      return <Youtube size={16} />;
    case "tiktok":
      return <Music2 size={16} />;
    case "x":
      return <Twitter size={16} />;
    default:
      return null;
  }
};

const Footer = () => {
  return (
    <footer className="bg-[#0a0410] border-t border-[#d4af37]/20 py-14">
      <div className="max-w-[900px] mx-auto px-6 flex flex-col items-center text-center">
        <img src={ASSETS.logo} alt="J. Crown" className="h-14 w-auto object-contain rounded mb-6" />
        <p className="heading-display gold-text text-xl tracking-wide">J. CROWN &copy; 2026</p>
        <p className="text-neutral-400 text-xs tracking-[0.3em] uppercase mt-2">
          {ARTIST.taglineShort}
        </p>

        <div className="flex gap-5 mt-7">
          {SOCIALS.map((s) => (
            <a
              key={s.key}
              href={s.href}
              aria-label={s.label}
              className="text-neutral-400 hover:text-[#e8c65a] transition-colors"
            >
              {iconFor(s.key)}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
